module.exports = __webpack_public_path__ + "static/media/photo1.a88a3f5a.jpg";